import React from 'react'
import { AVATAR_PLACEHOLDER } from '../helpers/source-icons'

// avatar URLs come from third parties (google photos, facebook lookaside)
// and can expire — fall back to the local placeholder instead of rendering
// a broken image
class Avatar extends React.Component {
  constructor(props) {
    super(props)
    this.state = { failed: false }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src && this.state.failed) {
      this.setState({ failed: false })
    }
  }

  render() {
    const { src, alt, className, style } = this.props
    const effective = this.state.failed || !src ? AVATAR_PLACEHOLDER : src
    return (
      <img
        src={effective}
        alt={alt || 'avatar'}
        className={className}
        style={style}
        onError={() => {
          if (!this.state.failed) this.setState({ failed: true })
        }}
      />
    )
  }
}

export default Avatar
